module.exports = __webpack_public_path__ + "BradescoSans-Bold.b056b9f4e916f595787f.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/BradescoSans/BradescoSans-Bold.woff
// module id = ../../../../../src/assets/fonts/BradescoSans/BradescoSans-Bold.woff
// module chunks = main